import { render, staticRenderFns } from "./CadCargos.vue?vue&type=template&id=924c5e0a"
import script from "./CadCargos.vue?vue&type=script&lang=js"
export * from "./CadCargos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports